
import TinymceEditor from './TinymceEditor.vue'
export default TinymceEditor
